import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import BenefitForm from "./BenefitForm";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";

class SubBenefits extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showBenefitInfo: false, rowKey: null, benefitTitle: ''
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    renderParams = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }

    Web_Benefits_Link = (props) => {
        const subTabNum = props.dataItem.tryGetValueFromExecRules(props.fieldInfo.Name, "SubTabNum", props.rowIndex);
        const benefitType = props.dataItem.tryGetValueFromExecRules(props.fieldInfo.Name, "BenefitType", props.rowIndex);
        const title = `${props.fieldInfo.Title} - ${i18next.t("Reason_restriction")}`;
        return (<div style={{cursor: 'pointer'}}><ActionLink onSelect={async () => {
            await this.showBenefitInfo(subTabNum, benefitType, title);
        }}>{props.value}</ActionLink></div>);
    }

    customization_Benefits = {
        "CalcKernelRep.PrefCatList": {
            customFieldExMap: {
                Web_Benefits_Link: (props) => this.Web_Benefits_Link(props)
            }
        }
    }

    showBenefitInfo = async (subTabNum, benefitType, title) => {
        this.setState({
            showBenefitInfo: true, rowKey: {SubTabNum: subTabNum, BenefitType: benefitType}, benefitTitle: title
        });
    }

    closeBenefitInfo = async () => {
        this.setState({showBenefitInfo: false});
    }

    render() {
        return (<>
                {/*<PlaceholderWrapper placeholderId="10"
                                    title={<><i
                                        className='fa fa-info'/> {i18next.t("Инструкция по работе с разделом")}</>}
                                    showSplitterLine={false}
                                    canCollapse={true}>
                    {renderHTML("Инструкция по работе с разделом")}
                </PlaceholderWrapper>*/}

                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-filter'/> {i18next.t('Filters')}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    <ComplexParam dataItem={this.props.dataItem_Params}
                                  parentDataItem={this.props.dataItem}
                                  readOnly={false}
                                  showSearchBar={true}
                                  showApplyButton={false}
                                  autoApplyParams={true}
                                  rootPath="/"
                                  renderParams={this.renderParams}
                    />
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="30"
                                    title={<><i
                                        className='fa fa-table'/> {i18next.t("Employees_With_Benefits")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    <GridView dataItem={this.props.dataItem} customObject={this.customization_Benefits}/>
                </PlaceholderWrapper>
                {this.state.showBenefitInfo && <BenefitForm onClose={this.closeBenefitInfo} rowKey={this.state.rowKey}
                                                            title={this.state.benefitTitle}/>}
            </>);
    }
}

SubBenefits.propTypes = {
    dispatch: PropTypes.func.isRequired, dataItem: PropTypes.object, dataItem_Params: PropTypes.object
}

SubBenefits.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.subBenefitsState.CalcKernelRep_PrefCatList,
        dataItem_Params: state.subBenefitsState.CalcKernelRep_PrefCatListParams
    }
}

export default connect(mapStateToProps)(SubBenefits);